import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import NotificationContainer from '../ui/NotificationContainer';
import { useTheme } from '../../contexts/ThemeContext';

function Layout() {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const { darkMode } = useTheme();
  const location = useLocation();
  
  // Check if current route is a dashboard detail page or chat page
  const isDashboardDetail = location.pathname.match(/^\/dashboards\/[^\/]+$/);
  const isChatPage = location.pathname === '/chat' || location.pathname.startsWith('/chat?');

  return (
    <div className="flex h-screen overflow-hidden bg-white dark:bg-slate-900">
      {/* Sidebar */}
      <Sidebar 
        mobileSidebarOpen={mobileSidebarOpen}
        setMobileSidebarOpen={setMobileSidebarOpen}
      />

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header 
          mobileSidebarOpen={mobileSidebarOpen}
          setMobileSidebarOpen={setMobileSidebarOpen}
        />
        
        <main 
          className={`flex-1 overflow-y-auto ${isDashboardDetail || isChatPage ? '' : 'p-6'}`} 
          style={{ backgroundColor: 'rgb(var(--app-background))' }}
        >
          {isDashboardDetail || isChatPage ? (
            <Outlet />
          ) : (
            <div className="max-w-7xl mx-auto px-6 py-8">
              <Outlet />
            </div>
          )}
        </main>
      </div>
      
      {/* Notifications */}
      <NotificationContainer />
    </div>
  );
}

export default Layout;